import type { ComponentPropsWithRef, JSX } from 'react';

import { cn } from '@change/ds-utils';

import { memo } from '@change-corgi/core-react/core';
import { parseHtml } from '@change-corgi/core-react/html';

type Props = ComponentPropsWithRef<'div'> & {
	aspectRatio?: number | string;
	embedHtml: string;
};

export const EmbeddedVideo = memo(
	({
		embedHtml,
		aspectRatio,
		className,
		style,
		ref,
		...rest
	}: Props & {
		ref?: React.RefObject<HTMLDivElement>;
	}): JSX.Element => {
		return (
			<div
				ref={ref}
				style={aspectRatio ? { ...style, aspectRatio } : style}
				className={cn(
					'overflow-hidden [&_embed]:h-full [&_embed]:w-full [&_iframe]:h-full [&_iframe]:w-full [&_object]:h-full [&_object]:w-full [&_video]:h-full [&_video]:w-full',
					className,
				)}
				{...rest}
			>
				{parseHtml(embedHtml, {
					allowedTags: ['iframe'],
					allowedAttrs: ['allow', 'allowfullscreen', 'frameborder', 'scrolling'],
				})}
			</div>
		);
	},
);
